import axios from './axiosInstance';

export const getVesselsList = async () => {
  const res = await axios.get(`/vessels/list`);
  return res.data.data;
};

export const getVesselStatus = async (vesselId) => {
  const res = await axios.get(`/vessels/status/recent/${vesselId}`);
  return res.data.data;
};

export const getVesselVoyage = async (vesselId) => {
  const res = await axios.get(`/vessels/voyage/recent/${vesselId}`);
  return res.data.data;
};